import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  for: "hasTribute",
  class: "rd-text-sm rd-mb-0 rd-ml-2.5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueRadioButton = _resolveComponent("VueRadioButton")!
  const _component_TributeInputComponent = _resolveComponent("TributeInputComponent")!
  const _component_AcknowledgeeInputComponent = _resolveComponent("AcknowledgeeInputComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "form-element-wrapper",
      style: _normalizeStyle({
        justifyContent: _ctx.component.customData.alignment || ''
    })
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        id: "hasTribute",
        class: "rd-relative",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.renderStore.hasTribute) = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.renderStore.hasTribute]
      ]),
      _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.component.customData.tributeOptInText), 1)
    ], 4),
    (_ctx.renderStore.hasTribute)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.component.customData.tributeType === _ctx.TributeType.Both)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["form-radio-group rd-inline-flex rd-leading-none", _ctx.isModalDisplay ? 'rd-mt-3' : 'rd-mt-6'])
              }, [
                _createVNode(_component_VueRadioButton, {
                  id: "isInHonorOf",
                  selected: _ctx.tributeType === _ctx.TributeType.InHonorOf,
                  value: _ctx.TributeType.InHonorOf,
                  class: "rd-leading-none",
                  name: "isInHonorOf",
                  modelValue: _ctx.tributeType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tributeType) = $event)),
                  labelText: "In honor of",
                  "is-admin": false
                }, null, 8, ["selected", "value", "modelValue"]),
                _createVNode(_component_VueRadioButton, {
                  id: "isInMemoryOf",
                  selected: _ctx.tributeType === _ctx.TributeType.InMemoryOf,
                  value: _ctx.TributeType.InMemoryOf,
                  class: "rd-leading-none rd-ml-5",
                  name: "isInMemoryOf",
                  modelValue: _ctx.tributeType,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tributeType) = $event)),
                  labelText: "In memory of",
                  "is-admin": false
                }, null, 8, ["selected", "value", "modelValue"])
              ], 2))
            : _createCommentVNode("", true),
          _createVNode(_component_TributeInputComponent, { component: _ctx.component }, null, 8, ["component"]),
          (_ctx.component.customData.hasAcknowledgement)
            ? (_openBlock(), _createBlock(_component_AcknowledgeeInputComponent, {
                key: 1,
                component: _ctx.component
              }, null, 8, ["component"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}